import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTable24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTable24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 4.5h13.5A1.5 1.5 0 0 1 20 6v1H3.5V6A1.5 1.5 0 0 1 5 4.5m-3 4V6a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v11.5a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm1.5 8.167v.833A1.5 1.5 0 0 0 5 19h3v-2.333zM14 19H9.5v-2.333H14zm1.5 0h3a1.5 1.5 0 0 0 1.5-1.5v-.833h-4.5zm0-3.833H20V12.5h-4.5zM14 12.5H9.5v2.667H14zm0-1.5H9.5V8.5H14zm1.5 0H20V8.5h-4.5zm-12-2.5H8V11H3.5zM8 15.167V12.5H3.5v2.667z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTable24);
